module.exports = __webpack_public_path__ + "static/pinkmuslinrompermain-62648ff8b1e49833709b8dec663c9b8b.jpeg";